import Cookies from 'js-cookie'

export const AUTH_TOKEN_NAME = 'auth_token'

/**
 * In days, the length of time for which an auth cookie is valid
 */
const AUTH_COOKIE_TIMEOUT = 90

/**
 * A list of query parameters that we want to maintain after login or signup
 */
export const QUERY_PARAMS_TO_PERSIST = ['rsvpToEvent', 'sid']

/**
 * Grabs the auth token from the user cookies.
 * @return {String} auth token
 */
export const getAuthToken = () => {
  return Cookies.get(AUTH_TOKEN_NAME)
}

/**
 * To be called only from authentication store to set auth token from
 * a query param or header when passed it from backend
 * @param {String} authTokenContents The value of the auth token as passed to us
 */
export const setAuthToken = (authTokenContents) => {
  return Cookies.set(AUTH_TOKEN_NAME, authTokenContents, {
    expires: AUTH_COOKIE_TIMEOUT,
    secure: true,
  })
}

/**
 * To be called ONLY from authentication store to delete auth tokens on
 * logout/etc.
 */
export const clearAuthToken = () => {
  return Cookies.remove(AUTH_TOKEN_NAME)
}
